import api from './api';
import {
  AuditLog,
  AuditLogQuery,
  AuditLogResponse,
} from '../types/audit.types';

export const AuditService = {
  getAuditLogs: async (query?: AuditLogQuery): Promise<AuditLogResponse> => {
    const response = await api.get<AuditLogResponse>('/audit', {
      params: query,
    });
    return response.data;
  },

  getCurrentUserLogs: async (query?: AuditLogQuery): Promise<AuditLogResponse> => {
    const response = await api.get<AuditLogResponse>('/audit/user', {
      params: query,
    });
    return response.data;
  },

  getUserLogs: async (userId: string, query?: AuditLogQuery): Promise<AuditLogResponse> => {
    const response = await api.get<AuditLogResponse>(`/audit/user/${userId}`, {
      params: query,
    });
    return response.data;
  },

  getEntityLogs: async (entityType: string, entityId: string, query?: AuditLogQuery): Promise<AuditLogResponse> => {
    const response = await api.get<AuditLogResponse>(`/audit/entity/${entityType}/${entityId}`, {
      params: query,
    });
    return response.data;
  },
};